// --- API response shapes (snake_case from auth service) ---

export interface LandingWaitlistEntryApiResponse {
  id: string;
  email: string;
  name: string | null;
  created_at: string;
}

export interface LandingWaitlistListApiResponse {
  items: LandingWaitlistEntryApiResponse[];
  total: number;
}

// --- Frontend types (camelCase) ---

export interface LandingWaitlistEntry {
  id: string;
  email: string;
  name: string | null;
  createdAt: string;
}

export interface LandingWaitlistListResponse {
  items: LandingWaitlistEntry[];
  total: number;
}

export interface LandingWaitlistFilters {
  search?: string;
  page?: number;
  limit?: number;
  sortBy?: 'created_at' | 'email' | 'name';
  sortOrder?: 'asc' | 'desc';
}

// --- Mappers ---

export function mapLandingWaitlistEntryFromApi(
  api: LandingWaitlistEntryApiResponse
): LandingWaitlistEntry {
  return {
    id: api.id,
    email: api.email,
    name: api.name,
    createdAt: api.created_at,
  };
}

export function mapLandingWaitlistListFromApi(
  api: LandingWaitlistListApiResponse
): LandingWaitlistListResponse {
  return {
    items: api.items.map(mapLandingWaitlistEntryFromApi),
    total: api.total,
  };
}
